import { c as _c } from "react/compiler-runtime";
import getVideoId from "get-video-id";
import YoutubeEmbed from "src/components/youtubembed/YoutubeEmbed";
import type IFilmklipp from "src/lib/types/Filmklipp";
import type { ITrailer } from "src/lib/types/Trailer";
import styles from './TrailerOverlayWrapper.module.css';

//#region [Props]
type YoutubeTrailerPlayerProps = {
  video?: ITrailer | IFilmklipp;
  videoId?: string;
  title?: string;
};
//#endregion

//#region [Component]
export default function YoutubeTrailerPlayer(t0) {
  const $ = _c(3);
  const {
    video,
    videoId,
    title
  } = t0;
  const _videoId = video?.youtubeUrl ? getVideoId(video.youtubeUrl)?.id : videoId;
  if (!_videoId) {
    return null;
  }
  const _title = video?.title ?? title ?? "Video";
  let t1;
  if ($[0] !== _title || $[1] !== _videoId) {
    t1 = <><article className={styles.SPlayerContainer}><div className={styles.SPlayer}><YoutubeEmbed youtubeId={_videoId} title={_title} /></div></article></>;
    $[0] = _title;
    $[1] = _videoId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
//#endregion